import verifyTelePathologyReport from "@custom/rtk-apis/report/verifyPathologyReport";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const verifyTelePathologyReportSlice = createSlice({
  name: "verifyTelePathologyReportSlice",
  initialState,
  reducers: {
    clearVerifyTelePathologyReports: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyTelePathologyReport.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(verifyTelePathologyReport.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload;
        state.msg = payload.msg;
      })
      .addCase(verifyTelePathologyReport.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default verifyTelePathologyReportSlice.reducer;
export const { clearVerifyTelePathologyReports } = verifyTelePathologyReportSlice.actions;
